import {
  is_valid_reason,
  trim_reason
} from '../../../util_components/required_reason_textarea/reason_rules';

// which note the "Edit Session Details" save must carry. Pure; apis re-validates all of it.
export const flag_on = (x) => parseInt(x, 10) === 1 || x === true;
const newly_on = (flag, saved) => flag_on(flag) && !flag_on(saved);

export function resolve_edit_reason(input) {
  const {
    status,
    original_status,
    cancelled_by_student,
    cancelled_by_teacher,
    original_cancelled_by_student,
    original_cancelled_by_teacher,
    teacher_time_corrected,
    status_change_reason,
    sent_flags
  } = input;

  const status_changed = status !== original_status;
  // sent_flags: the exact flags the save sends, judged as apis attribution_changed does (a sent value differing
  // from the stored one). Without it, only a flag ticked against the saved row is sent, so only that is a flip.
  const differs = (sent, saved) => sent !== undefined && flag_on(sent) !== flag_on(saved);
  const attribution_changed =
    status === 'CANCELLED' &&
    (sent_flags
      ? differs(sent_flags.student, original_cancelled_by_student) ||
        differs(sent_flags.teacher, original_cancelled_by_teacher)
      : newly_on(cancelled_by_student, original_cancelled_by_student) ||
        newly_on(cancelled_by_teacher, original_cancelled_by_teacher));
  // A new request time on an unchanged teacher cancel replaces the stored one, so it is audited with a note.
  const time_corrected = status === 'CANCELLED' && !attribution_changed && !!teacher_time_corrected;

  const reason_required = status_changed || attribution_changed || time_corrected;
  const reason = trim_reason(status_change_reason);

  return {
    status_changed,
    attribution_changed,
    time_corrected,
    reason_required,
    show_reason_textarea: reason_required,
    reason,
    reason_valid: !reason_required || is_valid_reason(reason)
  };
}

export const CANCEL_EMAIL_NOTE_LABEL = 'Notes that will go to students in cancel email';

// Mirrors apis update_session's GC cancel-email gate: status sent is CANCELLED, the row is a student's group-class
// booking, and cancelled_by_teacher ends up 1 (the value sent, else the stored one). Parent rows and 1-on-1s never email.
export function shows_cancel_email_note({
  session_type,
  status,
  sent_cancelled_by_teacher,
  saved_cancelled_by_teacher
}) {
  if (session_type !== 'GROUP_SESSION_STUDENT' || status !== 'CANCELLED') return false;
  const teacher =
    sent_cancelled_by_teacher === undefined
      ? saved_cancelled_by_teacher
      : sent_cancelled_by_teacher;
  return flag_on(teacher);
}

export default resolve_edit_reason;
